<template>
    <div v-if="(items.length >= minRequired)">
        <h2>Top New Musical Instruments &amp; Gear</h2>
        <div class="topnew-grid" >
            <a v-for="(item, index) in items" :key="item.itemid" :href="item.url" class="topnew-item" data-hp-section="top-new" :data-hp-slot="index">
                <div class="topnew-rank">{{ index + 1 }}</div>
                <div class="topnew-image">
                    <img width="300" height="300" :src="item.image300.replace('__b-new','__b-original')" :alt="item.productName">
                </div>
                {{ item.manufacturer.name }} {{ item.productName }}
            </a>
            <a href="/whats-new/" class="topnew-more" data-hp-section="top-new" data-hp-slot="7">
                <div class="topnew-more--content">
                    <div class="topnew-circle">
                        <div>SEE ALL</div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19.111" height="18.627" viewBox="0 0 19.111 18.627"><path d="M8.126,3.895l.947-.947a1.019,1.019,0,0,1,1.446,0l8.292,8.288a1.019,1.019,0,0,1,0,1.446l-8.292,8.292a1.019,1.019,0,0,1-1.446,0l-.947-.947a1.025,1.025,0,0,1,.017-1.463l5.14-4.9H1.024A1.021,1.021,0,0,1,0,12.643V11.278a1.021,1.021,0,0,1,1.024-1.024H13.282l-5.14-4.9A1.017,1.017,0,0,1,8.126,3.895Z" transform="translate(0 -2.647)" fill="#afafaf"/></svg>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            source: {
                default: '',
                type: String,
            },
            itemJson: {
                default: '',
                type: String,
            },
            name: {
                default: '',
                type: String,
            },
            minRequired: {
                default: 1,
                type: Number,
            },
            itemid: {
                default: '',
                type: String,
            },
            itemArray: {
                default() {
                    return [];
                },
                type: Array,
            },
        },
        data(){
            return {
                items: [],
                counter: 1,
            };
        },
        watch: {
            itemArray() {
                this.setItemsFromArray();
            }
        },
        created() {
            this.addEvents();
            this.fetchAsyncProducts();
            this.parseProductsJson();
            this.setItemsFromArray();
        },
        methods: {
            addEvents() {
                events.$on('productDataUpdate', this.productDataUpdate);
            },
            /**
             * Async fetch products
             */
            fetchAsyncProducts() {
                if (this.source) {
                    this.items = [];
                    events.$emit('fetch', { name: 'productDataUpdate', url: this.source });
                }
            },

            /**
             * Load from provided JSON, hacking it into the normal update process
             */
            parseProductsJson() {
                if (!this.source && this.itemsJson) {
                    const data = {};
                    data[this.name] = {};
                    data[this.name].items = JSON.parse(this.itemsJson);
                    // Vue.nextTick(() => {
                    //     this.productDataUpdate(data);
                    // });
                }
            },
            productDataUpdate(data) {
                if (!Object.prototype.hasOwnProperty.call(data, this.name)) {
                    return;
                }
                this.loaded = true;
                Object.keys(data[this.name]).forEach((key) => {
                    this[key] = data[this.name][key];
                });
            },
            setItemsFromArray() {
                if (this.itemArray) {
                    this.items = this.itemArray;
                    this.loaded = true;
                }
            }
        },
    };
</script>
